export const defaultColor = "#4618ac";
export const defaultIcon =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAALVBMVEVMaXH///////////////////////////////////////////////////////9xAJ22AAAADnRSTlMAIt8QQO/CpGCAUJBwj9Ry788AAAAJcEhZcwAAFiUAABYlAUlSJPAAAAENSURBVHicfVNbtsQgCAuK+GiH/S93DlVbtHNvfmxNBAwIbKAU960FlAL+QqTGLWg2WeUXW0U7KoBDNdNKp0GrBgbYVqegcNOqmgiQRUHP8QsCnGP9yatGlGs9e/6w80o9gqZLUF98AnL/ssvSizcnRlTzpGfzCDODqrk6/bkh5MoGcH3L0ZhbzZIPXstusKLaavuo0BAIwzGudcp8VSlDtEyvrQu4b9BRQXZw7rX93nkPKjk2L9DeMHFJyZcwksJlZZ8iz/EMvqjnL9zjKy5FfHx+BkaXe43+3vGvEXVggNpZ/Osg9jNhI/nGEuTzS+IaZPWFz/8x+qhsKL5J/tU4yfRDyi/aELmU0pb3/wX/sB0pwOApfQAAAABJRU5ErkJggg==";

export function getPlatforms(platforms: string) {
  const platformArray = platforms.split("/");

  const acceptPlatforms = ["win", "mac", "linux", "xbox", "ps"];

  const platformNames = platformArray.map((platform) => platform.trim());

  const filteredPlatforms = platformNames.filter((platform) =>
    acceptPlatforms.includes(platform.toLowerCase()),
  );

  return filteredPlatforms;
}

export const getIcons = (platform: string) => {
  const platformMap = new Map([
    ["win", "https://assets.gxcorner.games/obraz_2023_08_21_154708998_8ba128313e.png"],
    ["mac", "https://assets.gxcorner.games/obraz_2023_08_21_153507727_50c0bd11f1.png"],
    ["linux", "https://assets.gxcorner.games/obraz_2023_08_21_153737038_689f695b31.png"],
    [
      "xbox",
      "https://proxy.gxcorner.games/resizer/assets/obraz_2023_08_21_154736126_5b54cab834.png",
    ],
    [
      "ps",
      "https://proxy.gxcorner.games/resizer/assets/obraz_2023_08_21_154553319_59d8559097.png",
    ],
  ]);

  if (!platform || !platformMap.has(platform)) {
    return;
  }

  if (platform === "") {
    return;
  }

  return platformMap.get(platform);
};
